/**
 * Node width in pixels - used for calculations and corresponds to Tailwind w-60 class
 */
export const NODE_WIDTH_PX = 240;
